module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/325705/mv_sp-3f3cdc9bfea6adf02e0e97d687bdd750.png";